module.exports = __webpack_public_path__ + "img/LogoEglobal_Gris.6df5975b.png";